<template>
  <v-container class="pa-0 ma-0">
    <v-row v-for="(item, index) in items" :key="index" dense>
      <v-col cols="4" md="2">
        <currency-field
          label="Сумма"
          v-model="item.amount"
          @blur="onBlur(index)"
          :max="item.amount + paymentDeficit"
          :disabled="disabled"
        />
      </v-col>
      <v-col cols="8" md="4">
        <v-select
          :items="getItems(item.paymentType)"
          item-text="name"
          item-value="id"
          label="Способ оплаты"
          v-model="item.paymentType"
          @change="onChange(index)"
          :clearable="items.length > 1"
          :disabled="disabled"
        >
        </v-select>
      </v-col>
    </v-row>
    <v-row class="px-1 py-0" dense v-if="this.items.length < 2">
      <p class="caption grey--text">
        уменьшите сумму для добавления других способов оплат
      </p>
    </v-row>
  </v-container>
</template>
<script>
import { PaymentTypes } from "@/datastore/enums";
export default {
  name: "PaymentForm",
  props: ["amount", "value", "disabled"],
  data() {
    return {
      items: []
    };
  },
  created() {
    const val = this.value || { cash: this.amount };
    const keys = Object.keys(val).filter(key => val[key] > 0);
    this.items = keys.map(key => ({
      paymentType: key,
      amount: val[key]
    }));
  },
  watch: {
    amount(nv, ov) {
      let delta = nv - ov;
      for (let i = this.items.length - 1; i >= 0 && delta != 0; i--) {
        let item = this.items[i];
        item.amount += delta;
        if (item.amount > 0) {
          break;
        }
        delta = item.amount;
        this.items.splice(i, 1);
      }
    },
    items: {
      handler() {
        this.$emit("input", this.payment);
      },
      deep: true
    }
  },
  computed: {
    payment() {
      return this.items.reduce((p, item) => {
        p[item.paymentType] = item.amount;
        return p;
      }, {});
    },
    paymentAmount() {
      return this.items.reduce((sum, item) => sum + item.amount, 0);
    },
    paymentDeficit() {
      return this.amount - this.paymentAmount;
    }
  },
  methods: {
    onBlur(index) {
      if (this.paymentDeficit > 0) {
        this.addPaymentType();
      }
      if (!this.items[index].amount) {
        this.items.splice(index, 1);
      }
    },
    onChange(index) {
      if (!this.items[index].paymentType) {
        this.items.splice(index, 1);
        this.items[index - 1].amount += this.paymentDeficit;
      }
    },
    addPaymentType() {
      const items = this.getItems();
      if (items.length === 0) {
        return;
      }
      this.items.push({
        paymentType: items[0].id,
        amount: Math.max(this.paymentDeficit, 0)
      });
    },
    getItems(index) {
      return PaymentTypes.filter(
        item => item.id == index || !(item.id in this.payment)
      );
    }
  }
};
</script>
